import gameModeMethods from './GameMode'
import gameModeIdMethods from './GameMode.id'

export const GameModeServices = {
  ...gameModeMethods,
  id: gameModeIdMethods
}

export * from './GameMode.types'
